import { withPrefix } from 'gatsby';

export const ICON = withPrefix('/icons/favorites/red-heart.svg');
